import React from "react";

type Props = {
  text: string;
  style?: React.CSSProperties;
};

export default function TypingText({ text, style }: Props) {
  // We removed the typewriter effect here because the new vivid descriptions
  // are very long and take too long to type out, making the box appear empty initially.
  return <div style={{ ...styles.text, ...style }}>{text}</div>;
}

const styles: any = {
  text: {
    fontSize: 20,
    color: "#94A3B8",
    textAlign: "center"
  }
};